module.exports = __webpack_public_path__ + "img/linkedin.d4afa0f8.svg";